import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { _GlobalConstants } from '../../../services/globalConstants.service';
import {_UsersService} from "../../../services/users.service";
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {Observable} from "rxjs/Observable";

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'timing-h',
  templateUrl: './timing-h.component.html',
  styleUrls: ['./timing-h.component.css'],
})

export class TimingHistory implements OnInit {

  private subscription: any;
  private users: any;
  private accounts: any;

  constructor (private titleService: Title, private constants: _GlobalConstants, private usersService: _UsersService, private referenceData: _ReferenceDataService) { }

  ngOnInit() {

      //Set the page title
    this.titleService.setTitle("WiseRisk | Internal Allocation Event Log");

    this.subscription = Observable.forkJoin(this.usersService.getUsers(), this.referenceData.getAccounts()).subscribe((res: Array<any>) => {
      this.users = res[0];
      this.accounts = res[1];
      this.globalReady();
    })
  }

  globalReady() {

    // Exposure Evaluation Events.
    let constants = this.constants;
    let users = this.users;
    let accounts = this.accounts;

    var initrowdetails = function(index, parentElement, gridElement, datarecord) {

    		// Allocations
    		var sourceAllocations = {
    			localdata : datarecord.allocations,
    			datatype : "json",
    			datafields : [{
    				name : 'accountId',
    				type : 'string'
    			}, {
            name : 'accountDisplay',
            type : 'string',
            value: 'accountId',
            values: {
              source: accounts,
              name: 'displayName',
              value: 'accountId'
            }
          }, {
    				name : 'currency',
    				type : 'string'
    			}, {
    				name : 'quantity',
    				type : 'string'
    			}, {
    				name : 'purpose',
    				type : 'string'
    			}, {
    				name : 'contractType',
    				type : 'string'
    			}, {
    				name : 'valueDate',
    				type : 'date',
    				format : 'yyyy-MM-dd'
    			}]
    		};
    		var settingsAllocations = defaultGridViewSettings("#exposureEvaluationGridAccountAllocations", sourceAllocations);
    		settingsAllocations.width = '97%';
    		settingsAllocations.height = '99%';
    		settingsAllocations.columns = [{
    			text : 'Account',
    			columntype : 'textbox',
    			datafield : 'accountDisplay',
    			width : '15%'
    		}, {
    			text : 'Ccy',
    			columntype : 'textbox',
    			datafield : 'currency',
    			width : '10%'
    		}, {
    			text : 'Quantity',
    			columntype : 'textbox',
    			datafield : 'quantity',
    			width : '20%'
    		}, {
    			text : 'Purpose',
    			columntype : 'textbox',
    			datafield : 'purpose',
    			width : '15%'
    		}, {
    			text : 'Contract Type',
    			columntype : 'textbox',
    			datafield : 'contractType',
    			width : '20%'
    		}, {
    			text : 'Value Date',
    			columntype : 'datetimeinput',
    			datafield : 'valueDate',
    			cellsformat : 'yyyy-MMM-dd',
    			width : '20%'
    		}];

    		let gridDiv = $($(parentElement).children()[0]);
    		$(gridDiv).jqxGrid(settingsAllocations);
    	};

    	// initialize jqxGrid
    	var sourceRuleMatches = {
    		datatype : "json",
    		datafields : [{
    			name : 'eventId',
    			type : 'string'
    		}, {
    			name : 'eventTimestamp',
    			type : 'date',
    			format : 'yyyy-MM-dd HH:mm:ss.fff'
    		}, {
    			name : 'eventUserId',
    			type : 'string'
    		}, {
    			name : 'eventUserDisplayName',
    			type : 'string',
          value: 'eventUserId',
          values: {
    			  source: users,
            value: 'userId',
            name: 'displayName'
          }
    		}, {
    			name : 'eventIpAddress',
    			type : 'string'
    		}, {
    			name : 'eventAction',
    			type : 'string'
    		}, {
    			name : 'eventActionDisplayName',
    			type : 'string',
    			value: 'eventAction',
    			values: {
    				source: constants.getTranslatedValues('resources.ruleMatchEvent.action'),
    				value: 'value',
    				name: 'display'
    			}
    		}, {
    			name : 'allocations',
    			type : 'array'
    		}],
    		id : 'eventId',
    		url : '/ajax/rule-matches/events',
    		type : 'GET',
    		async : true
    	};
    	var settingsRuleMatches = defaultGridViewSettings("#exposureEvaluationGrid", sourceRuleMatches);
    	settingsRuleMatches.columns = [{
    		text : 'Timestamp',
    		columntype : 'datetimeinput',
    		datafield : 'eventTimestamp',
    		cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
    		width : '160'
    	}, {
    		text : 'User',
    		columntype : 'textbox',
    		datafield : 'eventUserDisplayName',
    		width : '110'
    	}, {
    		text : 'IP Address',
    		columntype : 'textbox',
    		datafield : 'eventIpAddress',
    		width : '80'
    	}, {
    		text : 'Exposure Evaluation Event',
    		columntype : 'textbox',
    		datafield : 'eventActionDisplayName',
    		width : '400'
    	}];
    	settingsRuleMatches.rowdetails = true;
    	settingsRuleMatches.initrowdetails = initrowdetails;
    	settingsRuleMatches.rowdetailstemplate = {
    		rowdetails : "<div id='exposureEvaluationGridAllocations' style='overflow: hidden;'></div>",
    		rowdetailsheight : 300,
    		rowdetailshidden : true
    	};

    	$("#exposureEvaluationGrid").jqxGrid(settingsRuleMatches);

      var settingEventActions = this.constants.getTranslatedValues('resources.settingEvent.action');

    	// Timing Schedule Settings.

    	defaultSettingsGrid("timingScheduleGrid", settingEventActions, users, "rule", '/ajax/rules/0/events');

    	// Timing Condition Settings.

    	defaultSettingsGrid("timingConditionGrid", settingEventActions, users, "ruleCondition", '/ajax/rule-conditions/events', 'Rule Condition');
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/timing-h/timing-h.component.ts